module.exports = __webpack_public_path__ + "img/Group.f594405f.svg";